<template>
    <BCol cols="12" :md="vsMd" :lg="vsLg" v-if="vsCols!=false">
        <ValidationProvider #default="validationContext" :name="vsName == '' ? '' : $t(vsName)" :rules="vsRules">
            <BFormGroup :label="vsName == '' ? '' : $t(vsName)" :label-for="vsName == '' ? '' : vsName" :class="vsRequired == '' ? 'required-field' : ''">
                <BFormInput :type="vsType" :disabled="vsDisabled" :id="vsName == '' ? '' : vsName" :placeholder="vsPlaceholder" :value="vsModel" @input="debounceValue($event)"/>
                <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{validationContext.errors[0]}} </BFormInvalidFeedback>
            </BFormGroup>
        </ValidationProvider>
    </BCol>
    <BCol v-else>
        <ValidationProvider #default="validationContext" :name="vsName == '' ? '' : $t(vsName)" :rules="vsRules">
            <BFormGroup :label="vsName == '' ? '' : $t(vsName)" :label-for="vsName == '' ? '' : vsName" :class="vsRequired == '' ? 'required-field' : ''">
                <BFormInput :type="vsType" :disabled="vsDisabled" :id="vsName == '' ? '' : vsName" :placeholder="vsPlaceholder" :value="vsModel" @input="debounceValue($event)"/>
                <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{validationContext.errors[0]}} </BFormInvalidFeedback>
            </BFormGroup>
        </ValidationProvider>
    </BCol>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { BCol, BFormGroup, BFormInput, BFormInvalidFeedback } from 'bootstrap-vue';
import formValidation from '@core/comp-functions/forms/form-validation';

export default {
    components:{ ValidationProvider, BCol, BFormGroup, BFormInput, BFormInvalidFeedback },
    props: ['vsName', 'vsDisabled', 'vsModel', 'vsMd', 'vsRules', 'vsRequired', 'vsLg', 'vsPlaceholder', 'vsCols', 'vsType'],
    emit: ['update:vsModel'],
    setup(props, { emit }) {
        const { getValidationState } = formValidation()
        let timer = 0;
        const delay = 500
        
        const debounceValue = function (event) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                emit('update:vsModel', event)
            }, delay)
        }

        return {
            getValidationState,
            debounceValue
        }
    },
}
</script>

<style scoped>
    .form-group {
        margin-bottom: 0px !important;
    }
</style>